import { useState, useEffect, useRef } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 50);

      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        // 스크롤 다운 → 숨기기
        setIsHidden(true);
      } else {
        // 스크롤 업 → 보이기
        setIsHidden(false);
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'} ${isHidden ? '-translate-y-full' : 'translate-y-0'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">

          {/* Logo — left side */}
          <a href="/" className="flex-shrink-0 leading-none text-left">
            <p className="text-[10px] tracking-[0.25em] uppercase text-gray-500 mb-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>
              Law Office of
            </p>
            <h1 className="text-xl font-bold tracking-widest uppercase text-gray-900 leading-none" style={{ fontFamily: "'Playfair Display', serif" }}>
              Hong-Min Jun
            </h1>
            <div className="flex justify-end">
              <p className="text-[9px] tracking-[0.2em] uppercase text-gray-400 mt-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                Attorney at Law
              </p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className={`text-xs tracking-wider uppercase hover:text-gray-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-gray-900'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
              Practice Areas
            </button>
            <button onClick={() => scrollToSection('attorneys')} className={`text-xs tracking-wider uppercase hover:text-gray-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-gray-900'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
              Our Team
            </button>
            <button onClick={() => scrollToSection('resources')} className={`text-xs tracking-wider uppercase hover:text-gray-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-gray-900'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
              Resources
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-xs tracking-wider uppercase hover:text-gray-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-gray-900'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-gray-900 text-white px-6 py-3 text-xs tracking-wider uppercase hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
              Contact
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`block h-0.5 w-full bg-gray-900 transition-all ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`block h-0.5 w-full bg-gray-900 transition-all ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-full bg-gray-900 transition-all ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-6">
            <div className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('services')} className="text-xs tracking-wider uppercase text-gray-900 hover:text-gray-600 transition-colors text-left cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Practice Areas
              </button>
              <button onClick={() => scrollToSection('attorneys')} className="text-xs tracking-wider uppercase text-gray-900 hover:text-gray-600 transition-colors text-left cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Our Team
              </button>
              <button onClick={() => scrollToSection('resources')} className="text-xs tracking-wider uppercase text-gray-900 hover:text-gray-600 transition-colors text-left cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Resources
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-xs tracking-wider uppercase text-gray-900 hover:text-gray-600 transition-colors text-left cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Testimonials
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-gray-900 text-white px-6 py-3 text-xs tracking-wider uppercase hover:bg-gray-800 transition-colors text-left cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
